<template>
    <div class="right-module">
        <!-- 类板块 -->
        <div class="module-type">
            <div class="module-tabs">
                <div class="tabs-header">
                    <div :class="`tab-head${activeName === 'first' ? ' isactive' : ''}`" @click="handleClick('first')">编链类</div>
                    <div :class="`tab-head${activeName === 'second' ? ' isactive' : ''}`" @click="handleClick('second')">其他类</div>
                </div>
                <div class="tabs-content">
                    <ChaininngType v-if="activeName === 'first'" />
                    <OtherType v-if="activeName === 'second'" />
                </div>
            </div>
            <!-- <el-tabs v-model="activeName" @tab-click="handleClick" style="height:100%" class="module-tabs">
                <el-tab-pane label="编链类" name="first">
                    <ChaininngType />
                </el-tab-pane>
                <el-tab-pane label="其他类" name="second">
                    <OtherType />
                </el-tab-pane>
            </el-tabs> -->
        </div>
        <!-- 通知板块 -->
        <div class="inform">
          <NoticeModule />
        </div>
    </div>
</template>

<script>
import ChaininngType from './chainingType'
import OtherType from './otherType'
import NoticeModule from './noticeModule'

export default {
    data() {
        return {
            activeName: 'first'
        }
    },
    components: {
        ChaininngType,
        OtherType,
        NoticeModule
    },
    methods: {
        handleClick(val) {
            this.activeName = val
        }
    }
}
</script>

<style lang="less">
.right-module {
    .module-type > .el-tabs.module-tabs {
        .el-tabs__header.is-top {
            .el-tabs__nav-wrap::after {
                height: 0px !important;
            }
        }
    }
    .el-scrollbar__wrap {
        overflow: auto;
    }
}
</style>

<style lang="less" scoped>
.right-module {
  height: 100%;
  /deep/.el-tabs__content {
    height: calc(100% - 55px);
    // overflow: auto;
  }
  
  .module-type {
    height: calc(100% - 270px);
    user-select: none;
    .module-tabs {
        height: 100%;
        .tabs-header {
            display: flex;
            width: 100%;
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            .tab-head {
                width: 50%;
                text-align: center;
                background: #F2F7FE;
                &:first-child {
                    border-top-left-radius: 3px;
                    border-bottom-left-radius: 3px;
                }
                &:last-child {
                    border-top-right-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
            }
            .tab-head.isactive {
                background: #1a7bfc;
                color: #ffffff;
                padding: 0 20px;
            }
        }
        .tabs-content {
            height: calc(100% - 40px);
            padding: 10px;
        }
    }
  }
}
</style>